// extracted by mini-css-extract-plugin
export default {"invalid":"AdminLogin_invalid__mwcPD"};